<template>
	<v-container grid-list-md>
		<v-card flat color="transparent" class="pa-0 ma-0">
			<v-card-text class="py-0">
				<v-layout row wrap>
					<v-flex xs12 md12>
						<filter-order
							v-model="filter"
							:outlets="outlets"
							:customers="customers"
							@filter="onFilter()"
						></filter-order>
					</v-flex>
					<v-flex xs12>
						<app-datatable
							printItem
							:title="$t('title.orders_datatable')"
							:endpoint="endpoint"
							:data="data"
							:headers="headers"
							:filter="filter"
							@onPrint="printItem"
							@onEdit="editItem"
							@onDelete="deleteItem"
							@onView="viewItem"
							:hasView="true"
							:hasPrint="true"
						>
							<template v-slot:[`item.subtotal`]="{ item }">
								{{ item.subtotal | currency }}
							</template>
							<template v-slot:[`item.discount`]="{ item }">
								{{ item.discount | currency }}
							</template>
							<template v-slot:[`item.total`]="{ item }">
								{{ item.total | currency }}
							</template>
							<template v-slot:[`item.paid`]="{ item }">
								<app-payment-status-button
									v-model="item.paid"
									block
								></app-payment-status-button>
							</template>
							<template v-slot:[`item.is_refundable`]="{ item }">
								<template v-if="item.is_refundable">
									<v-btn
										@click="openRefund(item)"
										color="primary"
									>
										{{ $t("Refund") }}
									</v-btn>
								</template>
								<template v-else>
									<v-chip
										v-if="item.has_refunds"
										color="success"
										small
									>
										{{ item.refunded_amount }} Refunded
									</v-chip>
									<span v-else class="text-uppercase">{{
										$t("Nonrefundable")
									}}</span>
								</template>
							</template>
						</app-datatable>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>

		<refund-form ref="refundForm" v-model="refund"></refund-form>
	</v-container>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
import pickBy from "lodash/pickBy";
import RefundForm from "@Shop/forms/RefundForm.vue";
import moment from "moment";

export default {
	components: {
		Link,
		RefundForm,
	},

	props: ["data", "outlets", "customers"],

	data() {
		return {
			filter: {
				range: {
					startDate: new moment().format("YYYY-MM-DD"),
					endDate: new moment().format("YYYY-MM-DD"),
				},
			},
			item: {},
			refund: {},
		};
	},
	computed: {
		endpoint() {
			return this.$route("tenant.orders.declined", {
				tenant: this.$page.props.tenant.id,
			});
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					sortable: false,
					searchable: false,
					align: "start",
					width: 80,
				},
				{
					text: this.$t("Code"),
					value: "code",
					sortable: false,
					searchable: false,
					width: 120,
				},
				{
					text: this.$t("Date"),
					value: "date",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Time"),
					value: "time",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Customer"),
					value: "customer_name",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Outlet"),
					value: "outlet_name",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Payment Method"),
					value: "payment_method_code",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Subtotal"),
					value: "subtotal",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Discount"),
					value: "discount",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Total"),
					value: "total",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Paid"),
					value: "paid",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Refund"),
					value: "is_refundable",
					sortable: false,
					searchable: false,
					align: "end",
				},
			];
		},
	},

	methods: {
		onFilter() {
			var filter = pickBy(this.filter);
			this.$inertia.get(
				this.endpoint,
				{ filter },
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},

		editItem(item) {
			this.$inertia.get(
				this.$route("tenant.orders.edit", {
					tenant: this.$page.props.tenant.id,
					order: item.uuid,
				})
			);
		},

		viewItem(item) {
			this.$inertia.get(
				this.$route("tenant.orders.show", {
					tenant: this.$page.props.tenant.id,
					order: item.uuid,
				})
			);
		},

		deleteItem(item) {
			this.item = Object.assign({}, item);
			this.$refs.deleteDialog.open();
		},

		printItem(item) {
			window.open(
				this.$route("tenant.order.print", {
					tenant: this.$page.props.tenant.id,
					order: item.uuid,
				})
			);
		},

		openRefund(item) {
			this.refund = Object.assign({}, item);
			this.$refs.refundForm.openRefund();
		},
	},
};
</script>